import React from "react";
import experience from "./Data/experience.json";

const Experience = () => {
  return (
    <div className="container ex" id="experience">
      <h1 className="text-center" >EXPERIENCE</h1>
      {experience.map((data) => {
        return (
          <>
            <div key={data.id} className="ex-items text-center my-5"
            data-aos="zoom-in"
      data-aos-duration="1000"
            >
              <div className="left">
                <img src={`/assets/${data.imageSrc}`} alt="" />
              </div>
              <div className="right">
                <h2>{data.role}</h2>
                <h3>"{data.organization}"</h3>
                <h4>
                  <span style={{ color: "yellowgreen" }}>
                    {data.startDate}
                    {" to "}
                    {data.endDate}
                    {", "}
                  </span>
                  <span style={{ color: "yellow" }}>{data.location}</span>
                </h4>
                <h5 style={{ color: "yellow" }}>{data.experiences[0]}</h5>
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
};

export default Experience;
